import axios from '@/axios';
import * as types from '../mutation-types'

export default {
    namespaced: true,

    state: {
        roles: [],
        trainingEvaluationTypes: [],
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/Role').then(({ data }) => {
                commit(types.STORE_ROLE, data);
                return data;
            })
        },
        

        create({ commit }, { name, parentRoleId, viewAllEmployee, permissions }) {
            return axios.post('/role', { name, parentRoleId, viewAllEmployee, permissions }).then((data) => {
                return data
            });
        },

        update({ commit }, { id, name, parentRoleId, viewAllEmployee, permissions }) {
            return axios.put(`/role/${id}`, { name, parentRoleId, viewAllEmployee, permissions }).then((data) => {
                return data
            });
        },

        delete({ commit }, { id }) {
            return axios.delete(`/role/${id}`);
        },
    },

    mutations: {
        [types.STORE_ROLE](state, roles) {
            state.roles = roles;
        },
        [types.STORE_TRAINING_EVALUATION_TYPES](state, trainingEvaluationTypes) {
            state.trainingEvaluationTypes = trainingEvaluationTypes;
        },
    }
}